function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, React.createElement("path", {
  d: "M2.143 11h9.643M5.232 7.804l-4.018 3.589M5.232 14.982l-4.018-3.59M4.75 1h10.393c.321 0 .857.429.857.696v19.286c0 .322-.59.375-.857.375H4.75"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-sign-out.d7fa09ce.svg";
export { SvgComponent as ReactComponent };